import { MenuActionListProps } from "@repo/core/components/layout/MenuActionsList/types";
import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useSelectStore } from "@repo/core/hooks/useSelectStore";
import { ROUTES } from "@repo/core/routes";
import { useStoresAndShopkeepersStore } from "@repo/core/stores/storesAndShopkeepers";

export const ReportsController = () => {
  const { selectedStore, selectedShopkeeper, hasMoreThanOneShopkeeper } =
    useStoresAndShopkeepersStore();

  const { isMobile } = useDimensions();
  const { push } = useNavigation();
  const { modalRef, handleOnSelectStore } = useSelectStore({});

  const reportsMenuSections: MenuActionListProps[] = [
    {
      title: "Propostas",
      menuItems: [
        {
          title: "Propostas Analisadas",
          description: "Resultado geral das propostas analisadas no período",
          onPress: () => push(ROUTES.reportAnalysedProposals),
          borderWidth: 0
        },
        {
          title: "Tipo de Aprovação",
          description: "Automáticas vs Autonomia",
          onPress: () => push(ROUTES.reportApprovalTypes),
          isVisible: !isMobile,
          borderWidth: 0
        },
        {
          title: "Motivos de Negação",
          description: "Mais informações sobre as propostas negadas",
          onPress: () => push(ROUTES.reportReasonDenial),
          borderWidth: 0
        },
        {
          title: "Relatório de Atendentes",
          description: "Resultado das propostas criadas por atendente",
          onPress: () => push(ROUTES.reportAttendants),
          isVisible: !isMobile,
          borderWidth: 0
        },
        {
          title: "Relatório Geral",
          description: "Resultado das propstas efetivadas do periodo",
          onPress: () => push(ROUTES.reportGeneralProposals),
          isVisible: !isMobile,
          borderWidth: 0
        }
      ]
    },
    {
      title: "Vendas",
      menuItems: [
        {
          title: "Vendas Mensais",
          description: "Vendas por Loja",
          onPress: () => push(ROUTES.reportMonthlySales),
          borderWidth: 0
        },
        {
          title: "Vendas por Loja",
          description:
            "Comparativo do resultado em relação aos pontos de vendas",
          onPress: () => push(ROUTES.reportSalesByStore),
          isVisible: !isMobile,
          borderWidth: 0
        },
        {
          title: "Carteira a Recebeer x Em Atraso",
          description: "Relação do valor a receber por data de vencimento",
          onPress: () => push(ROUTES.reportOverdueWallet),
          isVisible: !isMobile,
          borderWidth: 0
        }
      ]
    }
  ];
  return {
    isMobile,
    reportsMenuSections,
    modalRef,
    handleOnSelectStore,
    enableSelectStore: hasMoreThanOneShopkeeper,
    selectedStore,
    selectedShopkeeper
  };
};
